
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer">
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SavePageAsPdf',
  data () {
    return {
      name: 'Save page as PDF',
      desc: 'Save page as pdf using browser and attach it to the task. No params.'
    }
  },
  props: {
    model: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
   
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading'
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
